
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notifications",
      function () {
        return require("private-next-pages/notifications/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notifications"])
      });
    }
  